import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';

import { clearErrorMessage } from '../../actions/network';

interface IProps {
  errorMessage: string;
  cleanErrorMessage: () => {};
}

class ErrorMessageComponent extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
    this.state = {};

    this.onConformMessage = this.onConformMessage.bind(this);
  }

  render() {
    if (this.props.errorMessage !== '') {
      setTimeout(() => {
        this.props.cleanErrorMessage();
      }, 6 * 1000);
    }

    if (this.props.errorMessage !== '') {
      return (
        <div>
          <div id="ErrorMessage">
            <span>{this.props.errorMessage}</span>
            <button
              id="ConfirmErrorMessage"
              onMouseUp={this.onConformMessage}
              onTouchEnd={this.onConformMessage}
            >
              OK
            </button>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  onConformMessage(e: any) {
    e.preventDefault();
    this.props.cleanErrorMessage();
  }
}

const mapStateToProps = (state: any) => ({
  errorMessage: state.Network.errorMessage
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    cleanErrorMessage() {
      dispatch(clearErrorMessage());
    }
  };
};

const ErrorMessage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorMessageComponent);

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/index.tsx